import { render, staticRenderFns } from "./Sitemap.vue?vue&type=template&id=1b716ed2&scoped=true"
import script from "./Sitemap.vue?vue&type=script&lang=ts"
export * from "./Sitemap.vue?vue&type=script&lang=ts"
import style0 from "./Sitemap.vue?vue&type=style&index=0&id=1b716ed2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b716ed2",
  null
  
)

export default component.exports